import { 
  SlideCanvasPoint, 
  SlideCanvasBox 
} from '../components/SlideCanvas.types';


/**
 * Logic: Move Action (Natural Space)
 * 
 * @param originalBox Starting box before the current move gesture.
 * @param startPointNatural The pointer position (in image coordinates) when the drag started.
 * @param currentPointNatural The current pointer position (in image coordinates). 
 *        "Natural" space is the original high-resolution image space, which is 
 *        independent of the current canvas zoom/translation.
 */

export function applyMove(
  originalBox: SlideCanvasBox,
  startPointNatural: SlideCanvasPoint,
  currentPointNatural: SlideCanvasPoint
): { x: number; y: number } {
  // 1. Calculate the delta (change) in natural units.
  const dx = currentPointNatural.x - startPointNatural.x;
  const dy = currentPointNatural.y - startPointNatural.y;

  return {
    x: originalBox.x + dx,
    y: originalBox.y + dy
  };
}

